import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition, applyUrlDefaults } from './../../../wayfinder'
import aiosell from './aiosell'
import channelManagerB2cb97 from './channel-manager'
import owner from './owner'
import admins from './admins'
/**
* @see routes/admin.php:75
* @route '/motels/select'
*/
export const select = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: select.url(options),
    method: 'post',
})

select.definition = {
    methods: ["post"],
    url: '/motels/select',
} satisfies RouteDefinition<["post"]>

/**
* @see routes/admin.php:75
* @route '/motels/select'
*/
select.url = (options?: RouteQueryOptions) => {
    return select.definition.url + queryParams(options)
}

/**
* @see routes/admin.php:75
* @route '/motels/select'
*/
select.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: select.url(options),
    method: 'post',
})

/**
* @see routes/admin.php:75
* @route '/motels/select'
*/
const selectForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: select.url(options),
    method: 'post',
})

/**
* @see routes/admin.php:75
* @route '/motels/select'
*/
selectForm.post = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: select.url(options),
    method: 'post',
})

select.form = selectForm

/**
* @see \App\Http\Controllers\Admin\Motels\MotelController::index
* @see app/Http/Controllers/Admin/Motels/MotelController.php:40
* @route '/motels'
*/
export const index = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

index.definition = {
    methods: ["get","head"],
    url: '/motels',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Admin\Motels\MotelController::index
* @see app/Http/Controllers/Admin/Motels/MotelController.php:40
* @route '/motels'
*/
index.url = (options?: RouteQueryOptions) => {
    return index.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\Motels\MotelController::index
* @see app/Http/Controllers/Admin/Motels/MotelController.php:40
* @route '/motels'
*/
index.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Motels\MotelController::index
* @see app/Http/Controllers/Admin/Motels/MotelController.php:40
* @route '/motels'
*/
index.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: index.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Admin\Motels\MotelController::index
* @see app/Http/Controllers/Admin/Motels/MotelController.php:40
* @route '/motels'
*/
const indexForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Motels\MotelController::index
* @see app/Http/Controllers/Admin/Motels/MotelController.php:40
* @route '/motels'
*/
indexForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Motels\MotelController::index
* @see app/Http/Controllers/Admin/Motels/MotelController.php:40
* @route '/motels'
*/
indexForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

index.form = indexForm

/**
* @see \App\Http\Controllers\Admin\Motels\MotelController::create
* @see app/Http/Controllers/Admin/Motels/MotelController.php:287
* @route '/motels/create'
*/
export const create = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: create.url(options),
    method: 'get',
})

create.definition = {
    methods: ["get","head"],
    url: '/motels/create',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Admin\Motels\MotelController::create
* @see app/Http/Controllers/Admin/Motels/MotelController.php:287
* @route '/motels/create'
*/
create.url = (options?: RouteQueryOptions) => {
    return create.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\Motels\MotelController::create
* @see app/Http/Controllers/Admin/Motels/MotelController.php:287
* @route '/motels/create'
*/
create.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: create.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Motels\MotelController::create
* @see app/Http/Controllers/Admin/Motels/MotelController.php:287
* @route '/motels/create'
*/
create.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: create.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Admin\Motels\MotelController::create
* @see app/Http/Controllers/Admin/Motels/MotelController.php:287
* @route '/motels/create'
*/
const createForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: create.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Motels\MotelController::create
* @see app/Http/Controllers/Admin/Motels/MotelController.php:287
* @route '/motels/create'
*/
createForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: create.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Motels\MotelController::create
* @see app/Http/Controllers/Admin/Motels/MotelController.php:287
* @route '/motels/create'
*/
createForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: create.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

create.form = createForm

/**
* @see \App\Http\Controllers\Admin\Motels\MotelController::store
* @see app/Http/Controllers/Admin/Motels/MotelController.php:313
* @route '/motels'
*/
export const store = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(options),
    method: 'post',
})

store.definition = {
    methods: ["post"],
    url: '/motels',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Admin\Motels\MotelController::store
* @see app/Http/Controllers/Admin/Motels/MotelController.php:313
* @route '/motels'
*/
store.url = (options?: RouteQueryOptions) => {
    return store.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\Motels\MotelController::store
* @see app/Http/Controllers/Admin/Motels/MotelController.php:313
* @route '/motels'
*/
store.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\Motels\MotelController::store
* @see app/Http/Controllers/Admin/Motels/MotelController.php:313
* @route '/motels'
*/
const storeForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: store.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\Motels\MotelController::store
* @see app/Http/Controllers/Admin/Motels/MotelController.php:313
* @route '/motels'
*/
storeForm.post = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: store.url(options),
    method: 'post',
})

store.form = storeForm

/**
* @see \App\Http\Controllers\Admin\Motels\MotelController::show
* @see app/Http/Controllers/Admin/Motels/MotelController.php:127
* @route '/motels/{motel}'
*/
export const show = (args: { motel: string | number } | [motel: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: show.url(args, options),
    method: 'get',
})

show.definition = {
    methods: ["get","head"],
    url: '/motels/{motel}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Admin\Motels\MotelController::show
* @see app/Http/Controllers/Admin/Motels/MotelController.php:127
* @route '/motels/{motel}'
*/
show.url = (args: { motel: string | number } | [motel: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { motel: args }
    }

    if (Array.isArray(args)) {
        args = {
            motel: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        motel: args.motel,
    }

    return show.definition.url
            .replace('{motel}', parsedArgs.motel.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\Motels\MotelController::show
* @see app/Http/Controllers/Admin/Motels/MotelController.php:127
* @route '/motels/{motel}'
*/
show.get = (args: { motel: string | number } | [motel: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: show.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Motels\MotelController::show
* @see app/Http/Controllers/Admin/Motels/MotelController.php:127
* @route '/motels/{motel}'
*/
show.head = (args: { motel: string | number } | [motel: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: show.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Admin\Motels\MotelController::show
* @see app/Http/Controllers/Admin/Motels/MotelController.php:127
* @route '/motels/{motel}'
*/
const showForm = (args: { motel: string | number } | [motel: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: show.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Motels\MotelController::show
* @see app/Http/Controllers/Admin/Motels/MotelController.php:127
* @route '/motels/{motel}'
*/
showForm.get = (args: { motel: string | number } | [motel: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: show.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Motels\MotelController::show
* @see app/Http/Controllers/Admin/Motels/MotelController.php:127
* @route '/motels/{motel}'
*/
showForm.head = (args: { motel: string | number } | [motel: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: show.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

show.form = showForm

/**
* @see \App\Http\Controllers\Admin\Motels\MotelController::metrics
* @see app/Http/Controllers/Admin/Motels/MotelController.php:688
* @route '/motels/{motel}/metrics'
*/
export const metrics = (args: { motel: string | number } | [motel: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: metrics.url(args, options),
    method: 'get',
})

metrics.definition = {
    methods: ["get","head"],
    url: '/motels/{motel}/metrics',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Admin\Motels\MotelController::metrics
* @see app/Http/Controllers/Admin/Motels/MotelController.php:688
* @route '/motels/{motel}/metrics'
*/
metrics.url = (args: { motel: string | number } | [motel: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { motel: args }
    }

    if (Array.isArray(args)) {
        args = {
            motel: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        motel: args.motel,
    }

    return metrics.definition.url
            .replace('{motel}', parsedArgs.motel.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\Motels\MotelController::metrics
* @see app/Http/Controllers/Admin/Motels/MotelController.php:688
* @route '/motels/{motel}/metrics'
*/
metrics.get = (args: { motel: string | number } | [motel: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: metrics.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Motels\MotelController::metrics
* @see app/Http/Controllers/Admin/Motels/MotelController.php:688
* @route '/motels/{motel}/metrics'
*/
metrics.head = (args: { motel: string | number } | [motel: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: metrics.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Admin\Motels\MotelController::metrics
* @see app/Http/Controllers/Admin/Motels/MotelController.php:688
* @route '/motels/{motel}/metrics'
*/
const metricsForm = (args: { motel: string | number } | [motel: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: metrics.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Motels\MotelController::metrics
* @see app/Http/Controllers/Admin/Motels/MotelController.php:688
* @route '/motels/{motel}/metrics'
*/
metricsForm.get = (args: { motel: string | number } | [motel: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: metrics.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Motels\MotelController::metrics
* @see app/Http/Controllers/Admin/Motels/MotelController.php:688
* @route '/motels/{motel}/metrics'
*/
metricsForm.head = (args: { motel: string | number } | [motel: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: metrics.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

metrics.form = metricsForm

/**
* @see \App\Http\Controllers\Admin\Motels\ChannelManagerController::channelManager
* @see app/Http/Controllers/Admin/Motels/ChannelManagerController.php:36
* @route '/motels/{motel}/channel-manager'
*/
export const channelManager = (args: { motel: string | number } | [motel: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: channelManager.url(args, options),
    method: 'get',
})

channelManager.definition = {
    methods: ["get","head"],
    url: '/motels/{motel}/channel-manager',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Admin\Motels\ChannelManagerController::channelManager
* @see app/Http/Controllers/Admin/Motels/ChannelManagerController.php:36
* @route '/motels/{motel}/channel-manager'
*/
channelManager.url = (args: { motel: string | number } | [motel: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { motel: args }
    }

    if (Array.isArray(args)) {
        args = {
            motel: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        motel: args.motel,
    }

    return channelManager.definition.url
            .replace('{motel}', parsedArgs.motel.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\Motels\ChannelManagerController::channelManager
* @see app/Http/Controllers/Admin/Motels/ChannelManagerController.php:36
* @route '/motels/{motel}/channel-manager'
*/
channelManager.get = (args: { motel: string | number } | [motel: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: channelManager.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Motels\ChannelManagerController::channelManager
* @see app/Http/Controllers/Admin/Motels/ChannelManagerController.php:36
* @route '/motels/{motel}/channel-manager'
*/
channelManager.head = (args: { motel: string | number } | [motel: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: channelManager.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Admin\Motels\ChannelManagerController::channelManager
* @see app/Http/Controllers/Admin/Motels/ChannelManagerController.php:36
* @route '/motels/{motel}/channel-manager'
*/
const channelManagerForm = (args: { motel: string | number } | [motel: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: channelManager.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Motels\ChannelManagerController::channelManager
* @see app/Http/Controllers/Admin/Motels/ChannelManagerController.php:36
* @route '/motels/{motel}/channel-manager'
*/
channelManagerForm.get = (args: { motel: string | number } | [motel: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: channelManager.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Motels\ChannelManagerController::channelManager
* @see app/Http/Controllers/Admin/Motels/ChannelManagerController.php:36
* @route '/motels/{motel}/channel-manager'
*/
channelManagerForm.head = (args: { motel: string | number } | [motel: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: channelManager.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

channelManager.form = channelManagerForm

/**
* @see \App\Http\Controllers\Admin\Motels\MotelController::edit
* @see app/Http/Controllers/Admin/Motels/MotelController.php:382
* @route '/motels/{motel}/edit'
*/
export const edit = (args: { motel: string | number } | [motel: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: edit.url(args, options),
    method: 'get',
})

edit.definition = {
    methods: ["get","head"],
    url: '/motels/{motel}/edit',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Admin\Motels\MotelController::edit
* @see app/Http/Controllers/Admin/Motels/MotelController.php:382
* @route '/motels/{motel}/edit'
*/
edit.url = (args: { motel: string | number } | [motel: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { motel: args }
    }

    if (Array.isArray(args)) {
        args = {
            motel: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        motel: args.motel,
    }

    return edit.definition.url
            .replace('{motel}', parsedArgs.motel.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\Motels\MotelController::edit
* @see app/Http/Controllers/Admin/Motels/MotelController.php:382
* @route '/motels/{motel}/edit'
*/
edit.get = (args: { motel: string | number } | [motel: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: edit.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Motels\MotelController::edit
* @see app/Http/Controllers/Admin/Motels/MotelController.php:382
* @route '/motels/{motel}/edit'
*/
edit.head = (args: { motel: string | number } | [motel: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: edit.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Admin\Motels\MotelController::edit
* @see app/Http/Controllers/Admin/Motels/MotelController.php:382
* @route '/motels/{motel}/edit'
*/
const editForm = (args: { motel: string | number } | [motel: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: edit.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Motels\MotelController::edit
* @see app/Http/Controllers/Admin/Motels/MotelController.php:382
* @route '/motels/{motel}/edit'
*/
editForm.get = (args: { motel: string | number } | [motel: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: edit.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Motels\MotelController::edit
* @see app/Http/Controllers/Admin/Motels/MotelController.php:382
* @route '/motels/{motel}/edit'
*/
editForm.head = (args: { motel: string | number } | [motel: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: edit.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

edit.form = editForm

/**
* @see \App\Http\Controllers\Admin\Motels\MotelController::update
* @see app/Http/Controllers/Admin/Motels/MotelController.php:470
* @route '/motels/{motel}'
*/
export const update = (args: { motel: string | number } | [motel: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: update.url(args, options),
    method: 'put',
})

update.definition = {
    methods: ["put"],
    url: '/motels/{motel}',
} satisfies RouteDefinition<["put"]>

/**
* @see \App\Http\Controllers\Admin\Motels\MotelController::update
* @see app/Http/Controllers/Admin/Motels/MotelController.php:470
* @route '/motels/{motel}'
*/
update.url = (args: { motel: string | number } | [motel: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { motel: args }
    }

    if (Array.isArray(args)) {
        args = {
            motel: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        motel: args.motel,
    }

    return update.definition.url
            .replace('{motel}', parsedArgs.motel.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\Motels\MotelController::update
* @see app/Http/Controllers/Admin/Motels/MotelController.php:470
* @route '/motels/{motel}'
*/
update.put = (args: { motel: string | number } | [motel: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: update.url(args, options),
    method: 'put',
})

/**
* @see \App\Http\Controllers\Admin\Motels\MotelController::update
* @see app/Http/Controllers/Admin/Motels/MotelController.php:470
* @route '/motels/{motel}'
*/
const updateForm = (args: { motel: string | number } | [motel: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: update.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PUT',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\Motels\MotelController::update
* @see app/Http/Controllers/Admin/Motels/MotelController.php:470
* @route '/motels/{motel}'
*/
updateForm.put = (args: { motel: string | number } | [motel: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: update.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PUT',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

update.form = updateForm

/**
* @see \App\Http\Controllers\Admin\Motels\MotelController::togglePause
* @see app/Http/Controllers/Admin/Motels/MotelController.php:630
* @route '/motels/{motel}/toggle-pause'
*/
export const togglePause = (args: { motel: string | number } | [motel: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'patch'> => ({
    url: togglePause.url(args, options),
    method: 'patch',
})

togglePause.definition = {
    methods: ["patch"],
    url: '/motels/{motel}/toggle-pause',
} satisfies RouteDefinition<["patch"]>

/**
* @see \App\Http\Controllers\Admin\Motels\MotelController::togglePause
* @see app/Http/Controllers/Admin/Motels/MotelController.php:630
* @route '/motels/{motel}/toggle-pause'
*/
togglePause.url = (args: { motel: string | number } | [motel: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { motel: args }
    }

    if (Array.isArray(args)) {
        args = {
            motel: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        motel: args.motel,
    }

    return togglePause.definition.url
            .replace('{motel}', parsedArgs.motel.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\Motels\MotelController::togglePause
* @see app/Http/Controllers/Admin/Motels/MotelController.php:630
* @route '/motels/{motel}/toggle-pause'
*/
togglePause.patch = (args: { motel: string | number } | [motel: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'patch'> => ({
    url: togglePause.url(args, options),
    method: 'patch',
})

/**
* @see \App\Http\Controllers\Admin\Motels\MotelController::togglePause
* @see app/Http/Controllers/Admin/Motels/MotelController.php:630
* @route '/motels/{motel}/toggle-pause'
*/
const togglePauseForm = (args: { motel: string | number } | [motel: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: togglePause.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PATCH',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\Motels\MotelController::togglePause
* @see app/Http/Controllers/Admin/Motels/MotelController.php:630
* @route '/motels/{motel}/toggle-pause'
*/
togglePauseForm.patch = (args: { motel: string | number } | [motel: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: togglePause.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PATCH',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

togglePause.form = togglePauseForm

/**
* @see \App\Http\Controllers\Admin\Motels\MotelController::destroy
* @see app/Http/Controllers/Admin/Motels/MotelController.php:659
* @route '/motels/{motel}'
*/
export const destroy = (args: { motel: string | number } | [motel: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

destroy.definition = {
    methods: ["delete"],
    url: '/motels/{motel}',
} satisfies RouteDefinition<["delete"]>

/**
* @see \App\Http\Controllers\Admin\Motels\MotelController::destroy
* @see app/Http/Controllers/Admin/Motels/MotelController.php:659
* @route '/motels/{motel}'
*/
destroy.url = (args: { motel: string | number } | [motel: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { motel: args }
    }

    if (Array.isArray(args)) {
        args = {
            motel: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        motel: args.motel,
    }

    return destroy.definition.url
            .replace('{motel}', parsedArgs.motel.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\Motels\MotelController::destroy
* @see app/Http/Controllers/Admin/Motels/MotelController.php:659
* @route '/motels/{motel}'
*/
destroy.delete = (args: { motel: string | number } | [motel: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

/**
* @see \App\Http\Controllers\Admin\Motels\MotelController::destroy
* @see app/Http/Controllers/Admin/Motels/MotelController.php:659
* @route '/motels/{motel}'
*/
const destroyForm = (args: { motel: string | number } | [motel: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: destroy.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'DELETE',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\Motels\MotelController::destroy
* @see app/Http/Controllers/Admin/Motels/MotelController.php:659
* @route '/motels/{motel}'
*/
destroyForm.delete = (args: { motel: string | number } | [motel: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: destroy.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'DELETE',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

destroy.form = destroyForm

const motels = {
    select: Object.assign(select, select),
    index: Object.assign(index, index),
    create: Object.assign(create, create),
    store: Object.assign(store, store),
    show: Object.assign(show, show),
    metrics: Object.assign(metrics, metrics),
    aiosell: Object.assign(aiosell, aiosell),
    channelManager: Object.assign(channelManager, channelManagerB2cb97),
    edit: Object.assign(edit, edit),
    update: Object.assign(update, update),
    togglePause: Object.assign(togglePause, togglePause),
    destroy: Object.assign(destroy, destroy),
    owner: Object.assign(owner, owner),
    admins: Object.assign(admins, admins),
}

export default motels